import PropTypes from 'prop-types'
import { Checkbox } from 'antd'
import { connect } from 'react-redux'
import ClassRight from '../ClassRight.component'
import { FormOutlined } from '@ant-design/icons'
import Lecture from '../lecture/Lecture.component'
import React, { useState, useContext } from 'react'
import { CourseContext } from '../../../ClassContent/CourseDetail.container'

//
// redux + selectors
import * as classSelectors from '../../../../../redux/selectors/class'
import { actions as classActions } from '../../../../../redux/modules/class'
import { actions as courseActions } from '../../../../../redux/modules/course'
import {  useParams } from 'react-router-dom'
import history from '../../../../../history'
import FinishedLectureList from './components/FinishedLectureList'
import { useQuestionBlocksToggle } from '../../../hooks/useQuestionBlocksToggle'

const propTypes = {
  user: PropTypes.object,
  redo: PropTypes.bool,
  getFinishedLectures: PropTypes.func.isRequired,
  finishedLectures: PropTypes.array,
  setClassProperties: PropTypes.func.isRequired,
}

// Exportado sem o `connect` para os testes de integração (o default segue conectado) —
// mesmo padrão de src/pages/lectures/index.tsx.
export function DesktopLecture(props) {
  const {courseId, courseClassId} = useParams();
  const [lectureStarted, setLectureStarted] = useState(false)
  //
  const { selectedClass, handlePrintTest, loadingDownloadText, course} = useContext(CourseContext)
  const { redo } = props
  // Pulado no fluxo "refazer questões erradas" (redo), que não exibe o toggle.
  const { hasQuestionBlocks, useQuestionBlocks, handleToggleQuestionBlocks } =
    useQuestionBlocksToggle(selectedClass?.id, { skip: redo })

  const handleReview = (lectureId, idAula) => {
    history.push(`/lectures/${courseId}/${courseClassId}/${lectureId}`, {selectedClass, course, idAula})
  }

  return (
    <>
      <ClassRight
        sectionTitle={redo ? 'Refaça as questões erradas da prova' : 'Faça a prova'}
        content={
          !redo ? (
            // `content` é renderizado dentro de um <span> (ClassRight.component.js), então o
            // wrapper também precisa ser inline — um <div> aqui seria aninhamento inválido.
            <span className="exam-prompt">
              <span>Teste seus conhecimentos, faça a prova!</span>
              {hasQuestionBlocks && (
                <Checkbox
                  className="exam-prompt-blocks-toggle"
                  checked={useQuestionBlocks}
                  onChange={(event) => handleToggleQuestionBlocks(event.target.checked)}
                >
                  Dividir questões em blocos
                </Checkbox>
              )}
            </span>
          ) : undefined
        }
        loadingDownloadText={loadingDownloadText}
        handlePrintTest={handlePrintTest}
        icon={<FormOutlined/>}
        buttonText={redo ? 'Clique aqui para iniciar a prova' : 'Iniciar'}
        handleClick={() => {
          history.push(`/lectures/${courseId}/${courseClassId}`, {selectedClass, course})
        }}
      />
      {!redo && (
        <ClassRight
          sectionTitle="Provas realizadas"
          content={
            <FinishedLectureList
              handleReview={handleReview}
              classId={selectedClass?.id}
            />
          }
        />
      )}
      <Lecture redo={redo} lectureStarted={lectureStarted} setLectureStarted={setLectureStarted} />
    </>
  )
}

const mapStateToProps = (state, props) => ({
  finishedLectures: classSelectors.finishedLectures(state, props),
  isLoading: classSelectors.isLoading(state, props),
})

const mapDispatchToProps = (dispatch) => ({
  getFinishedLectures: (classId, next) =>
    dispatch(classActions.getFinishedLectures(classId, next)),
  setClassProperties: (courseId, step, next) =>
    dispatch(courseActions.setClassProperties(courseId, step, next)),
})

DesktopLecture.propTypes = propTypes
export default connect(mapStateToProps, mapDispatchToProps)(DesktopLecture)
